import { useMetricTemplates } from 'features/app-config';
import React, { Suspense, useCallback, useMemo, useState } from 'react';
import { Goal } from 'shared/types/goal';

import {
  GoalMetricsFormContext,
  GoalMetricsFormContextProps,
} from './goal-metrics-form-context';

const loadDialog = () => import('shared/dialogs/goal-metrics-form');
const GoalMetricsFormDialog = React.lazy(async () => ({
  default: (await loadDialog()).GoalMetricsFormDialog,
}));

export type GoalMetricsFormProviderProps = {
  children: React.ReactNode;
};

export const GoalMetricsFormProvider: React.FC<
  GoalMetricsFormProviderProps
> = ({ children }) => {
  const metricTemplates = useMetricTemplates();
  const [goal, setGoal] = useState<Goal | null>(null);

  const closeDialog = useCallback(() => setGoal(null), []);

  const value = useMemo<GoalMetricsFormContextProps>(
    () => ({
      onOpenMetricsForm: (goal: Goal) => setGoal(goal),
    }),
    [],
  );

  return (
    <GoalMetricsFormContext.Provider value={value}>
      {children}
      <Suspense>
        {goal && (
          <GoalMetricsFormDialog
            open
            goal={goal}
            metricTemplates={metricTemplates}
            onClose={closeDialog}
          />
        )}
      </Suspense>
    </GoalMetricsFormContext.Provider>
  );
};
